import { LoadingIndicatorComponent } from '@23degrees/ui/atoms/loading-indicator';
import { Component } from '@angular/core';

@Component({
    selector: 'page-loading',
    template: '<loading-indicator [ignoreColors]="true"></loading-indicator>',
    imports: [LoadingIndicatorComponent]
})
export class PageLoadingComponent {}
